angular.module('autoremind.communications')
    .directive('communicationsTargetSurvey', ['jobService', 'templateService',
    function (jobService, templateService) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-target-survey.html',
            link: function (scope) {
            }
        };
    }]);
//# sourceMappingURL=communications-target-survey.js.map